import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ReceivingDocument, SearchCriteria, CountingDocument } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReceivingDocumentService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    search(tenantId: string, branchId: string, criteria: SearchCriteria): Observable<ReceivingDocument[]> {
        return this.http.post<ReceivingDocument[]>(this.serviceUtils.getBaseUrl('receivingDocument', tenantId, branchId) + `/search`, criteria);
    }

    searchByKeyword(
        tenantId: string,
        branchId: string,
        keyword: string,
        status: 'active' | 'completed' | 'pendingApproval' | 'all',
        criteria: SearchCriteria,
        showLoading = true,
    ): Observable<ReceivingDocument[]> {
        if (status === 'active' || status === 'completed') {
            criteria.items.push({
                condition: 'and',
                name: 'statusId',
                operator: status === 'completed' ? '=' : '<>',
                value: '2',
            });
        } else if (status === 'pendingApproval') {
            criteria.items.push({
                condition: 'and',
                name: 'countingDocument.submittedDate',
                operator: '<>',
                value: null,
            });
            criteria.items.push({
                condition: 'and',
                name: 'countingDocument.approvalDate',
                operator: '=',
                value: null,
            });
        }

        return this.http.post<ReceivingDocument[]>(
            this.serviceUtils.getBaseUrl('receivingDocument', tenantId, branchId) + `/search/keyword/${encodeURIComponent(keyword)}`,
            criteria,
            {
                headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
            },
        );
    }

    get(tenantId: string, branchId: string, id: string): Observable<ReceivingDocument> {
        return this.http.get<ReceivingDocument>(this.serviceUtils.getBaseUrl('receivingDocument', tenantId, branchId) + `/${id}`);
    }

    approve(tenantId: string, branchId: string, id: string): Observable<ReceivingDocument> {
        return this.http.put<ReceivingDocument>(this.serviceUtils.getBaseUrl('receivingDocument', tenantId, branchId) + `/approve/${id}`, {});
    }

    assignCountingDocument(
        tenantId: string,
        branchId: string,
        receivingDocumentId: string,
        countingDocument: CountingDocument,
    ): Observable<ReceivingDocument> {
        return this.http.put<ReceivingDocument>(
            this.serviceUtils.getBaseUrl('receivingDocument', tenantId, branchId) + `/assign-counting-document/${receivingDocumentId}`,
            countingDocument,
        );
    }
}
